import React from 'react'
import PropTypes from 'prop-types'

const Header = ({ image, h1, h2, children }) =>
  <header className="header fadeInUp" style={{backgroundImage: `url(${ROOT_DATA_NEW.home.headerImage})`}}>
    <div>
      <img src={image} alt="" className="profile-pic"/>
      <div className="header__body">
        <h1>{h1}</h1>
        <h2>{h2}</h2>
        {children}
      </div>
    </div>
  </header>

Header.defaultProps = {
  h1: '',
  h2: '',
  children: '',
  image: 'https://placehold.it/400x400'
}

Header.propTypes = {
  h1: PropTypes.string,
  h2: PropTypes.string,
  children: PropTypes.node,
  image: PropTypes.string
}

export default Header



// WEBPACK FOOTER //
// src/javascripts/components/Header.js